/** @format */

import { Component, computed, OnInit, Signal } from '@angular/core';

import { InventoryExceededStatus } from '@pdp/data-access/interfaces';
import {
	selectInventoryExceededStatus,
	selectMaxOrMinQuantityAlert
} from '@pdp/add-to-cart/data-access';
import { Store } from '@ngrx/store';
import { HmfAlertBannerComponent } from '@dsg-tech/homefield-angular';

@Component({
	selector: 'pdp-feature-add-to-cart-alerts',
	standalone: true,
	imports: [HmfAlertBannerComponent],
	templateUrl: './add-to-cart-alerts.component.html',
	styleUrl: './add-to-cart-alerts.component.scss'
})
export class AddToCartAlertsComponent implements OnInit {
	inventoryExceededStatus: Signal<InventoryExceededStatus>;
	inventoryExceededText = computed(() => {
		const status = this.inventoryExceededStatus();
		if (status?.inventoryExceeded) {
			return `Only ${status.maxInventory} unit(s) available to be purchased`;
		} else {
			return undefined;
		}
	});

	maxOrMinQuantityAlert: Signal<string>;

	constructor(public store: Store) {}

	ngOnInit() {
		this.inventoryExceededStatus = this.store.selectSignal(selectInventoryExceededStatus);
		this.maxOrMinQuantityAlert = this.store.selectSignal(selectMaxOrMinQuantityAlert);
	}
}
